import TimeZonePage from './TimeZonePage';

export default TimeZonePage;
